export default {
  "action": "アクション",
  "all": "すべて",
  "allAssetHoldings": "全資産の保有残高",
  "apiSpotTradingVolume": "API経由の現物取引高",
  "apply": "申請する",
  "assetHoldingCalcQualification": "資産の保有残高が要件の場合、抽選券を2枚または3枚獲得できるかどうかは、どのように決まりますか？",
  "assets": "通貨",
  "assetSnapshotRecord": "計測期間中は、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）における資産残高が、1時間ごとのスナップショットで記録されます。",
  "available": "利用可能",
  "avgCryptoAssetInSnapshotPeriod": "{x}日間の計測期間中、以下のアカウントにおける全暗号資産の日次平均保有残高が日次スナップショットで記録されます。",
  "avgDailyAndFinalHoldingsInfo": "日次平均保有残高は、ウォレット残高の1時間ごとのスナップショットから算出されます。最終的な平均保有残高は、日次ウォレット残高の平均となります。",
  "avgDailyHoldingsSnapshotPeriod": "{x}日間の計測期間中、以下のアカウントにおける日次平均保有残高が1時間ごとのスナップショットで記録されます。",
  "avgPledgeAmountBetweenTimeRangeUtc": "{time1}～{time2}（UTC）の期間中、{minPledgeAmount} {currency}以上の平均保有残高を達成しよう",
  "balance": "利用可能残高",
  "botValidateErrCode101": "最低投資価格が低すぎます。",
  "botValidateErrCode102": "最低投資価格が高すぎます。",
  "botValidateErrCode103": "最高投資価格が低すぎます。",
  "botValidateErrCode104": "最高投資価格が高すぎます。",
  "botValidateErrCode105": "グリッドが少なすぎます。",
  "botValidateErrCode106": "グリッドが多すぎます。",
  "botValidateErrCode107": "投資額が低すぎて、投資要件を満たしていません。",
  "botValidateErrCode108": "投資額が高すぎて、契約の投資枠を超えています。",
  "botValidateErrCode109": "利食価格が低すぎます。",
  "botValidateErrCode110": "利食価格が高すぎます。",
  "botValidateErrCode111": "損切価格が低すぎます。",
  "botValidateErrCode112": "損切価格が高すぎます。",
  "botValidateErrCode113": "参入価格が低すぎます。",
  "botValidateErrCode114": "参入価格が高すぎます。",
  "buyDepositAdditionalAmount": "コミットするために、<b>{additional_amount} {currency}</b>を追加で購入または入金する必要があります。表示されているMNTは、資金調達アカウント、現物アカウント、およびデリバティブアカウント（または総合取引アカウントおよびインバースアカウント）のMNTまたはUSDTの残高を除いて、メインアカウント現在の利用可能残高のみを表します。詳しいスナップショットの説明については、以下の説明を参照してください。",
  "buyDepositAdditionalAmountBeforeTimeUtc": "{time}（UTC）までに<b>{additional_amount} MNT</b>を追加で購入または入金する必要があります。",
  "buyDepositAdditionalCurrencyForSubscription": "コミットするために、{currency}を追加で購入または入金する必要があります（<a href=\"{url}\" target=\"_blank\">必要な金額はこちら</a>）。",
  "buyDepositForLotteryTip": "割当抽選に参加するために、{currency}を追加で購入または入金する必要があります（<a href=\"{url}\" target=\"_blank\">必要な金額はこちら</a>）。",
  "buyMore": "追加購入する",
  "buyMoreForHigherAllocation": "{currency}を追加で購入して、より多くのトークン割当を獲得しよう。",
  "calendar": "カレンダー",
  "cancel": "いいえ",
  "cancelAll": "すべてをキャンセル",
  "cancelBak": "キャンセル",
  "cancelOrder": "キャンセル",
  "checkSnapshotResult": "スナップショットの結果を見る",
  "chooseOne": "（どちらかを選択）",
  "clickToJoinSale": "Bybitで開催中の「{token}ローンチパッド」トークンセールに一緒に参加しましょう！次のリンクをクリック：",
  "close": "閉じる",
  "commitSubscriptionReminder": "おめでとうございます！  サブスクリプションの資格が獲得します。資産をスナップショット期間の終了まで保持し、その後、コミット期間中のに戻り、MNTトークンをコミットしてください。",
  "commitTokenSale": "MNTもしくはUSDTをコミットして、{token}ローンチパッドのトークンセールに参加しよう！",
  "confirm": "はい",
  "contract_account": "デリバティブアカウント",
  "copyFailed": "コピーできませんでした",
  "copySuccessFully": "コピーしました",
  "createErrorCode400": "お客様から送信されたデータに不正なパラメータが含まれています。詳しくは、エラーメッセージとその詳細をご確認ください。",
  "createErrorCode401": "残高が不足しています。",
  "createErrorCode402": "ボットの作成数が上限に達しました。",
  "createErrorCode403": "禁止",
  "createErrorCode404": "リクエストされたリソースは見つかりませんでした。",
  "createErrorCode407": "お客様のアカウントタイプでは、取引ボットのサブアカウントは作成できません。",
  "createErrorCode408": "定期投資対象が重複して選択されています。",
  "createErrorCode409": "投資限度額が無効です。",
  "createErrorCode410": "投資限度額が無効です。",
  "createErrorCode411": "ボットが終了しました。",
  "createErrorCode412": "USDデリバティブアカウントに更新中",
  "createErrorCode500": "内部サーバーエラー",
  "createErrorCode501": "内部処理のタイムアウト",
  "createErrorCode503": "積立ボットは現在終了できません。買い注文をしている可能性があります。",
  "currency": "通貨",
  "currentOperationFailed": "失敗しました！もう一度お試しください。",
  "deposit": "入金",
  "depositAdditionalUsdtBeforeTimeUtc": "{time}（UTC）までに<b>{additional_amount} USDT</b>を追加で入金する必要があります。",
  "depositLotteryInfoUpdate": "すでに提案された{currency}を追加で入金済みで、いかなる通貨の出金や取引を行っていない場合は、割当抽選に参加するために再度入金を行う必要はありません。最終的な平均保有残高は、{time}の3:30（UTC）に更新されます。",
  "derivativesAccount": "デリバティブアカウント",
  "derivativesTrading": "デリバティブ取引",
  "detail": "詳細",
  "details": "詳細",
  "dialog_confirm_btn": "確認",
  "direction": "方向",
  "earnLotteryTicketsInfo": "割当抽選に参加すると、VIPステータス、現物取引高、日次平均保有資産に応じて、<b>{tickets}枚の抽選券</b>を獲得できます。",
  "earnLotteryTicketsInfoNew": "割当抽選に参加すると、VIPステータス、現物取引高、日次平均保有資産に応じて、{tickets}枚の抽選券を獲得できます。",
  "earnMaxVipLotteryTicketsInfo": "割当抽選に参加すると、VIPステータス、現物取引高、日次平均保有資産に応じて、<b>{tickets}枚の抽選券</b><b1>（追加枚数の上限）</b1>を獲得できます。",
  "eeaCustomerParticipationProhibited": "本イベントは、オーストリア、ベルギー、ブルガリア、クロアチア、キプロス、チェコ共和国、デンマーク、エストニア、フィンランド、フランス、ドイツ、ギリシャ、ハンガリー、アイルランド、イタリア、ラトビア、リトアニア、ルクセンブルク、マルタ、オランダ、ポーランド、ポルトガル、ルーマニア、スロバキア、スロベニア、スペイン、スウェーデン、アイスランド、リヒテンシュタイン、ノルウェー（以下「欧州経済領域」）在住のお客様向けではありません。欧州経済地域にお住いのお客様のご参加は固くお断りいたします。",
  "eligibilityLaunchpadEventNotice": "ローンチパッドイベントに参加するには、必要な金額のMNTまたはUSDTを購入、もしくはBybitアカウントに入金し、計測期間が終了するまでその資産を保有してください。その後、コミット期間中にMNTまたはUSDTトークンをステーキングします。",
  "eligibleForLaunchpad": "<p>ローンチパッドに参加するためには、個人（レベル1）または法人向け本人確認を完了してください。制限対象国のお客様は、Bybitローンチパッドにご参加いただけません。<p>\n\n<p>本人確認は、コミット開始前に完了する必要があります。こちらをクリックして、本人確認を完了してください。<p>",
  "end": "終了時間",
  "ended": "終了済み",
  "ended1": "終了済み",
  "eventParticipationEligibility": "残念ですが、お客様は本イベントに参加することができません。詳細については、利用規約をご確認ください。",
  "example": "例",
  "exampleBak": "例：",
  "fiat": "法定通貨",
  "filter": "絞り込む",
  "finalSnapshotCalculationNotification": "現在、最終的な計測結果を算出中です。参加資格の有無は{time}（UTC）以降にご確認いただけます。",
  "finalSnapshotCalculationNotificationNew": "現在、最終的な計測結果を算出中です。{time}（UTC）に再度このページに戻ってコミットを行ってください。",
  "finalTokenAllocation": "<p>スナップショット期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）におけるMNTおよびUSDTの両方の残高がカウントされます。<p>コミット期間中に、Bybitローンチパッドにアクセスし、<b>「今すぐコミット」</b>ボタンをクリックして、新しいプロジェクトに一定額のMNTをコミットする必要があります。<p>\n\n<p>最終的なトークン割当額 =（コミットしたMNTの数量 ÷ 全参加者がコミットしたMNTの総量）× プロジェクトに割り当てられた新規トークンの合計数量<p>\n\n<p>具体例を挙げて、シミュレーションしてみましょう：<p>\n\n<p>田中さんがコミットしたMNT数量：1,000 MNT<p>\n<p>全参加者がコミットしたMNT総数量：1,000,000 MNT<p>\n<p>プロジェクトに割り当てられた新規トークン（$βとする）の合計数量：3,000,000 β<p>\n\n<p>この場合、田中さんの最終的な割当額は、以下の式から「3,000 β」と算出できます：<p>\n<p>（1,000 MNT ÷ 1,000,000 MNT）× 3,000,000 β<p>",
  "finish": "確認",
  "from": "開始時間",
  "fundingAccount": "資金調達アカウント",
  "fundingAccountSnapshotInfo": "<p>- 計測期間中の資金調達アカウントでは、MNTまたはUSDTの残高、およびローンチプールと積立ステーキングで預け入れたMNTまたはUSDTの残高が自動的にスナップショットで記録されます。その他の商品（例：定期ステーキング、デュアル資産投資、コピートレードPro）で預け入れた資産はカウント対象外です。</p>",
  "fundingAndDerivativesAc": "<p>スナップショット期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）におけるMNTおよびUSDTの両方の残高がカウントされます。\n\n<p>- 資金調達アカウントについて、積立ステーキングおよびローンチパッドに預け入れているMNTは、自動的に資金調達アカウントのスナップショットに計上されます。Bybit資産運用における他の商品（流動性マイニングなど）、およびBybit仕組商品（デュアル資産投資など）に預け入れたMNTはスナップショットには含まれません。<p>ウォレット残高は、実現損益によって変動する可能性があります。<p>",
  "gainEarlyAccessToTokens": "将来有望なプロジェクトのトークンを、Bybitでいち早く入手！",
  "getLotteryTicketNotice": "{minPledgeAmount} {currency}をコミットすると、抽選券を1枚受け取れます。詳しくは、<a href=\"{url}\" target=\"_blank\">>より多くの抽選券を手に入れる方法</a>をご参照ください。",
  "getMoreTickets": "より多くの抽選券を入手する",
  "getVerified": "本人確認を行う",
  "global_setting_quick_order_desc": "<p>1.成行注文（クイック注文）</p>\n<p>2.入力した注文数量と実際に約定された購入数量が若干異なる場合があります。</p>",
  "global_setting_quick_order_label": "クイック注文",
  "global_setting_title": "カスタム設定（現物取引に適用）",
  "gridDcaBot": "現物取引ボット、積立ボット",
  "hint": "備考",
  "holdAvgMinPledgeBetweenTimeUtc": "{time1}～{time2}（UTC）の期間中、{minPledgeAmount} {currency}以上の平均保有残高を達成しよう",
  "holdingsCalculationForMntOrUsdt": "MNTのコミットやUSDTの割当抽選のために、保有残高はどのように算出されますか？",
  "initialTokenSale": "{token}の初回トークンセール",
  "innovateQuota": "購入上限",
  "inverseDerivativesAccount": "インバースアカウント",
  "joinLaunchpadPurchaseLink": "{token}のローンチパッドに私と一緒に参加して、発売価格で購入しませんか。次のリンクをクリック：",
  "joinLaunchpadPurchaseTip": "{token}のローンチパッドに私と一緒に参加して、発売価格で購入しませんか。",
  "joinLotteryBeforeTimeUtc": "{time}（UTC）より前に割当抽選に参加してください。",
  "joinLotteryWinAllocation": "{currency}で{token}の割当抽選に参加する",
  "joinLotteryWithAvgBalance": "{minPledgeAmount} {currency}以上の平均アカウント残高を使用して、{token}の割当抽選に参加します。",
  "joinSubscriptionBeforeTimeUtc": "{time}（UTC）より前にコミットを行ってください。",
  "joinTokenSale": "{token}ローンチパッドに参加",
  "kline": "チャート",
  "l_version_tip": "Bybitローンチパッドイベントに参加するには、Bybitアプリを最新バージョンにアップデートしてください。",
  "launchpad": "ローンチパッド",
  "launchPad": "ローンチパッド",
  "leverage": "レバレッジ",
  "leverage_off_trade_tip": "レバレッジ取引を行うには、まずレバレッジ機能を有効にしてください。",
  "leverageCloseErrInfo": "処理に失敗しました。すべての返済を完了してから、マージン取引をオフにしてください。",
  "leverageCloseTips": "Failed to disable Margin Trading, as there are active Spot Margin orders in your account.",
  "leveragedTokens": "レバレッジトークン",
  "leverageLoanTips": "USDデリバティブアカウントの必要証拠金と維持証拠金の利用率がしきい値を超えているため、このアクションは完了できません。",
  "leverageTryAgain": "システムエラーです。後でもう一度お試しください。",
  "liquidationErrorInfo": "処理に失敗しました。お客様のアカウントで強制決済がトリガーされました。",
  "loading_text": "読込中",
  "loan": "借入",
  "loan_spot_account": "現物アカウント",
  "login": "ログイン",
  "loginToCheck": "ログイン＆チェック",
  "lotteryDrawDefinition": "抽選会とはなんですか？",
  "lotteryEligibilityCongrats": "おめでとうございます！お客様には割当抽選の参加資格があります。",
  "lotteryEligibilityReminder": "おめでとうございます！ サブスクリプションの資格が獲得します。資産をスナップショット期間の終了まで保持し、その後、コミット期間中のに戻り、USDTトークンをコミットしてください。",
  "lotteryJoinErrorTip": "日次平均保有残高が条件を満たさないため、割当抽選に参加することができません。次回のローンチパッドに参加する際は、十分な{currency}を入金するようにしてください。",
  "lotteryTicketsAllocation": "<p>抽選会では、要件を満たし抽選券を獲得したローンチパッド参加者の中から、ランダムに当選者を選出します。見事当選すると、新規トークンの割り当てを受けることができます。<p>\n\n<p>各ローンチパッドイベントにおいて、参加者が獲得できる抽選券の上限数は、スナップショット期間中に完了したタスク数に応じて決定されます。抽選券の枚数が多ければ多いほど、トークン割り当ての当選率もアップするしくみです。<p>",
  "lp_active_active": "計測期間中",
  "lp_active_before": "計測未開始",
  "lp_active_end": "終了",
  "lp_active_joined": "イベントに参加登録しました！",
  "lp_asset_statistics": "計測期間",
  "lp_asset_statistics_desc": "お客様の5日間のウォレット残高（ドルで計算、現物及びデリバティブアカウントの全てのペアを含み）のスナップショットが1時間ごとに記録されます。残高が多いほど、多くの {currency}を獲得できます！",
  "lp_balance": "ウォレット残高",
  "lp_balance_explain": "計測期間中の日次ウォレット平均残高は、スナップショットで1時間ごとに記録され、翌日日本時間午後0時（正午）に更新されます。\n\n<br>9月22日、高田さんはBybitに登録し、9時から1時間ごとに100ドルを入金するとします。9月22日のウォレット残高は以下通り記録されます：9時：100 ドル；10時：200ドル；11時：300ドル；12時：400ドル；13時：500ドル…翌日8時：2,400ドル。\n<br>この場合、9月22日高田さんの日次平均ウォレット残高は1,250ドル [ (100ドル + 200ドル + 300ドル + 400ドル + … + 2400ドル )/ 24]と計算されます。\n\n<br>残高が多ければ多いほど、より多くのBITを受け取ることができるということです。",
  "lp_balance_explain_close": "たたむ",
  "lp_balance_explain_open": "もっと見る",
  "lp_btn_join": "今すぐ参加登録",
  "lp_btn_kyc": "本人確認を行う",
  "lp_issue_num": "総割当量",
  "lp_item_desc": "BITはBitDAOのネイティブトークンです",
  "lp_join": "参加登録期間",
  "lp_join_desc": "イベントに参加するには、参加登録期間中に「今すぐ参加登録」ボタンをクリックして必要な手順を完了してください。一度イベントに参加すると、最大3,500 {currency}が無料で獲得できる抽選及びトークン配布に、自動的に登録されます。参加登録期間開始後、参加登録ボタンをクリックしてください。毎日のウォレット残高スナップショットは自動的に記録されます。本人確認（KYC）レベル1を完成する必要がありますので、ご注意ください。",
  "lp_link_bps": "ホワイトペーパー",
  "lp_link_rule": "イベント規約",
  "lp_link_website": "ウェブサイト",
  "lp_no_kyc": "ローンチパッドに参加するためには、本人確認レベル1が必須です。",
  "lp_project_community": "SNSチャネル",
  "lp_project_desc": "紹介",
  "lp_project_desc_content": "BitDAOは世界最大級の分散型自律組織 (DAO) で、開かれた金融サービスと分散型トークン経済の実現を目指しています。",
  "lp_project_highlight": "ハイライト",
  "lp_project_highlight_desc": "BitDAOは世界最大級のDAOで、Peter Thiel、Founders Fund、Pantera、Dragonfly、Spartan、Bybitなど、多くのパートナーに支援されています。\n\n<br>Bybitは毎年、BitDAOに対して定期的に資金拠出を行っており、2021年のレート換算で年間100億ドルを超えます。\n\n<br>BitDAOは、暗号資産の発展を促し、財政及び人的資源を活用し、DeFiの成長に貢献します。\n\n<br>BitDAOは、トークンスワップや共同開発などの分野で協力していただけるパートナーを募集しています。主なミッションは研究開発、流動性活性化の促進、及び資金調達を通してBitDAOを支援することです。",
  "lp_project_title": "BitDAO — すべてのBITが未来を担う",
  "lp_table_label1": "配布総額",
  "lp_table_label2": "トークン配布",
  "lp_table_label3": "抽選",
  "lp_table_label4": "ユーザーごとの上限 (トークン配布)",
  "lp_table_label5": "ユーザーごとの上限 (抽選)",
  "lp_tdk_desc": "最新の有望な暗号資産プロジェクトをBybitで見つけよう。適応性のあるフレームワーク、正当性、スケーラビリティの可能性を持つプロジェクトのみを取り扱うようにしています。",
  "lp_tdk_title": "Bybitローンチパッド | 有望なプロジェクトトークンの初売りに参加しよう",
  "lp_time": "時間",
  "lp_token_distribution": "配布期間",
  "lp_token_distribution_desc": "お客様の獲得できる{currency}数量は抽選結果による数量及び5日間の日次平均残高による数量の合計です。{currency}がお客様の現物アカウントに入金されるまで30分ほどかかりますのでご了承下さい。",
  "lp10_introduce": "Tap Fantasy（TAP）：P2Eと融合した画期的ファンタジーMMORPG",
  "lp10_introduce_desc2": "Tap Fantasyはブロックチェーン上で無料プレイが楽しめるMMORPGです。NFTスキンを使用した200以上のキャラクターでプレイしながら稼ぐ（P2E）ことができます。プレイヤーはオープンワールドを自由に探索して自分だけのメタバースを築き上げることができます。",
  "lp10_introduce_desc3": "<br>Tap Fantasyは、当初TapTap FantasyとしてFacebookゲームとして配信されましたが、瞬く間に世界的人気を博したロールプレイング・アドベンチャーゲームのひとつとなりました。6ヶ月足らずで150万人以上のユーザーと約40万人のデイリーアクティブユーザーを獲得しました。TapTap Fantasyは2021年9月末までに全世界で2,000万人を超えるユーザーを獲得しました。\n\n<br>Tap Fantasyは、ゲーム開発者がゲームプレイ・モジュールを設計・作成できるコーディングいらずのマップエディタを提供しています。さらに、デザイナーはNFTのプロフィール画像、壁紙、建物の形状、キャラクターのスキン外観を独自に作成することが可能です。NFTスキンを購入すると、VIP専用のハンティングエリアにアクセス可能となり、そこではゲーム内トークンや他のプレイヤーがデザインしたNFTスキンを獲得できます。 \n\n<br>TAPトークンは、通常のDAOガバナンス機能に加え、Tap FantasyのDAOガバナンストークンとしても機能します。TAPトークンは、通常のDAOガバナンス機能に加え、Tap FantasyのDAOガバナンストークンとして機能します。 ",
  "lp10_project_desc": "P2Eと融合した画期的ファンタジーMMORPG",
  "lp3_introduce": "Genopets — NFTが切り拓く新たなゲームのカタチ",
  "lp3_introduce_desc2": "GameFiやメタバースが急速に拡大していく中で、Move-to-Earn（運動して稼ぐ）を組み込みSolanaで開発されたNFTゲームとして今話題沸騰中なのがGenopetsです。このゲームでは、プレイヤーは現実世界で運動したり行動したりすることで、仮想世界であるGenoverseを探索し、暗号資産を獲得することができます。",
  "lp3_introduce_desc3": "<br>Genopetsは、モバイルゲームと、ブロックチェーンエコシステムのPlay-to-Earn（遊んで稼ぐ）の二つの分野を融合させ、Move-to-Earnという新しいゲームを切り拓きました。\n\n<br>Genopetsは、プレイヤーの現実世界での物理的な動きを、Genoverseでの行動と価値の創造に反映させることができます。\n\n<br>Genopetsは、Konvoy Ventures、Pantera Capital、および暗号資産、ゲーム、フィットネス分野の著名なエンジェル投資家が主導する830万ドルの資金調達を達成しました。",
  "lp3_project_desc": "Genopets — NFTが切り拓く新たなゲームのカタチ",
  "lp4_introduce": "Pintu — インドネシアの暗号資産取引所",
  "lp4_introduce_desc2": "2020年4月に設立されたPintuは、インドネシア商品先物取引監督庁（BAPPEBTI）の下で認可された暗号資産取引所です。",
  "lp4_introduce_desc3": "<br>Pintuは暗号資産が初めてのユーザーに焦点を当てており、シリーズA1の資金調達ラウンドで3500万ドルを調達しています。\n\n<br>Pintuは、Pantera Capital、Coinbase Ventures、Intudo Venturesなどの主要な暗号資産投資家に支えられています。\n\n<br>Pintuは、設立から1年半で100万人以上のアクティブユーザーを獲得しました。",
  "lp4_project_desc": "インドネシアの暗号資産取引所",
  "lp5_introduce": "Symbiosis Finance (SIS) — マルチチェーン対応の流動性プロトコル",
  "lp5_introduce_desc2": "Symbiosis Finance（SIS）は、分散型のマルチチェーン流動性プロトコルであり、ユーザーは資金の唯一の所有者でありながら、低いスリッページでチェーン間のトークンを交換することができます。",
  "lp5_introduce_desc3": "<br>Symbiosis Financeは、すべてのレイヤー2ソリューションと、Solana、Algorand、Nearなどの有望なレイヤー1プラットフォームの分散型取引所の流動性を集約しています。\n\n<br>Symbiosis Financeは、すべてのチェーンで可能な限り多くのトークンペアを対象としているため、無限のクロスチェーン流動性を提供するとともに、任意のトークンペア間のスワップに最適なレートを提供しています。\n\n<br>Symbiosis Relayers Networkは、ブロックチェーンに依存しない許可制のピアツーピアネットワークで、暗号資産のインセンティブメカニズムを内蔵しています。",
  "lp5_project_desc": "マルチチェーンに対応した新たな流動性プロトコル",
  "lp6_daily_wallet_desc": "4日間の計測期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（またはUSDデリバティブアカウント/統合取引アカウント、インバースデリバティブアカウント）の日次平均残高が1時間ごとのスナップショットで記録されます。日次平均残高は、翌日の12:00（日本時間）に更新されます。\n\n例：10月28日にAさんがBybitアカウントに登録し、6:00（日本時間）から1時間ごとに100 MNTを資金調達アカウントに入金した場合、残高の1時間ごとのスナップショット記録は、6:00（日本時間）時点で100 MNT、7:00（日本時間）時点で200 MNT、8:00（日本時間）時点で300 MNTとなります。この場合、10月28日の資金調達アカウントの日次平均残高は25 MNTとなります。\n\n[(100 + 200 + 300) ÷ 24] = 25\n\nAさんの10月29日時点のMNT日次平均残高（資金調達アカウント）は、10月30日12:00以降に25 MNTに更新されます。",
  "lp6_daily_wallet_desc_v2": "{snapshot_days}日間の計測期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）の日次平均保有残高が1時間ごとのスナップショットで記録されます。その日の日次平均保有残高は、翌日の3:00（UTC時間）に更新されます。\n\n例えば、田中さんが10月28日にBybitアカウントを作成し、21:00（UTC時間）から1時間ごとに100 MNTを現物アカウントに入金したとします。この場合、1時間ごとの残高スナップショットは、「21:00（UTC時間）→100 MNT、22:00（UTC時間）→200 MNT、23:00（UTC時間）→300 MNT」として記録されます。また、10月28日の現物アカウントのMNTの日次平均保有残高は25 MNTになります。\n\n[(100 + 200 + 300) ÷ 24] = 25\n\n10月29日3:00（UTC時間）以降、田中さんの10月28日の日次平均MNT保有残高（現物アカウント）は25 BITに更新されます。",
  "lp6_introduce": "Realy Metaverse (REAL) — NFTとメタバースの融合した新世界",
  "lp6_introduce_desc2": "Realy Metaverse（REAL）は、NFTをベースとした音楽、ゲーム、ファッション、コレクターズアイテムなどを利用・作成・交換できる新しい形のメタバースです。",
  "lp6_introduce_desc3": "<br>Realy Metaverseは、Solanaに基づいて構築された初めてのストリートカルチャーをテーマにしたメタバースであり、「生活しながら稼ぐ」というコンセプトを実現しようとしています。\n\n<br>Realy Metaverseでは、実態を有するアイテムのNFTを提供しています。実際のアイテムにはNFCチップが埋め込まれており、その真偽を容易に確認することができます。\n\n<br>Realy Metaverseは、1万匹のユニークなクマのコレクションである「Bearache」をイーサリアムネットワーク上で開発しました。Bearacheは単なる仮想世界のペットではなく、会員制クラブに参加するカギにもなります。\n\n<br>Realy Metaverseは、Alameda Research、Multicoin、Three Arrows Capital、District0xなどから支援を受けています。",
  "lp6_join_step1_desc": "<b>{date}</b>以降のお客様のデリバティブアカウント、現物アカウント及び資産運用アカウントの日次平均BIT残高が{amount}以上である必要があります。（直近の整数に切り上げられます。）",
  "lp6_join_step2_desc": "新規プロジェクトに一定額のBITをコミットすることができます。これを行うには、コミット期間中に「今すぐコミット」ボタンを押す必要があります。コミット可能なBITの最大額は、5日間の計測期間中のデリバティブアカウント、現物アカウント及び資産運用アカウントにおける日次平均BIT残高に基づいて算出されます。コミットされた額のBITがロックされ、最終{currency}を配布するまで振替、出金または取引を行うことができないことにご留意ください。資産運用アカウントまたはデリバティブアカウントでBITを保有している場合も手動でBITを現物アカウントに振り替えてください。",
  "lp6_project_desc": "NFTとメタバースが融合した新世界",
  "lp7_introduce": "izumi Finance(IZI) ー チェーンに囚われない次世代のLaaSプロバイダー",
  "lp7_introduce_desc2": "IZIは、Uniswap V3のマルチチェーンに対応したLaaS（サービスとしての流動性）プロバイダーであるizumi Financeのネイティブトークンです。",
  "lp7_introduce_desc3": "<br>Izumi Financeは、Uniswap V3上でプログラム可能な流動性マイニングを可能にする初のマルチチェーン対応ファーミングプロトコルです。\n \n <br>このプロトコルでは、「Uniswap V3」のAMM（自動マーケットメーカー）機能を他のレイヤー2チェーンでも利用できるようにします。\n \n <br>チェーンをまたぐトークン移動にかかる時間とコストの低減を目指しており、Izumiを使ったチェーン間のトークン移動にかかる時間は1分以内、ガス代は1ドル以下になる見込みです。\n \n <br> Izumi Financeは、IOSG Ventures、Everest Ventures Group (EVG)、Cadenza Capital Management、Fenbushi Capital、GSR Ventures、CyberX、HashKey、Nansenなどの企業から支援を受けています。",
  "lp7_project_desc": "チェーンに囚われない次世代のLaaSプロバイダー",
  "lp8_introduce": "Kasta（KASTA）—暗号資産の送金を無料かつ簡素化する創造的破壊者",
  "lp8_introduce_desc2": "Kastaは、個人間の暗号資産送金をボーダレスに、そして迅速に行える新たな暗号資産決済プラットフォームです。ガス代の高騰が大きな問題となる中で、Kastaでは、同一の暗号資産で行われる決済、またはユーザー間の送金の手数料ゼロを実現しています。",
  "lp8_introduce_desc3": "<br>Kastaを利用すれば、暗号資産について全く知識がない方でも、手間もコストを掛けずに簡単に暗号資産を保管・送金・受け取ることができます。Kastaでは、ユーザーが電話番号／メールアドレスを入力、あるいはQRコードをスキャンするだけで暗号資産での決済を実行することができます。\n \n<br>Kastaのスワップエンジンを利用すると、送金で使用する通貨に関わらず、ユーザーは受取りを希望する暗号資産/法定通貨を自由に選ぶことができます。その他にも、Kastaと銀行間の送金、Kastaのネットワーク外のデビットカードに直接支払うことを可能にするなど、今まででは考えられない程手軽に利用できる法定通貨の出入金サービスを現在開発中です。\n \n<br>さらにKastaでは、ユーザーがその場で支払わずともオンラインストアで商品を購入できる、独自の決済ソリューションの開発にも取り組んでいます。Kastaを利用すると、購入後いつどのように支払うかをユーザーが選択できるようになります。\n \n<br>KastaのエコシステムのネイティブトークンであるKASTAは、低額の交換手数料、キャッシュバックなど、さまざまなメリットを保有者に提供しています。",
  "lp8_project_desc": "暗号資産の送金を無料かつ簡素化する創造的破壊者",
  "lp9_introduce": "MONSTER GALAXY P2E (GGM)：ブロックチェーンを活用した新次元のモバイルゲーム",
  "lp9_introduce_desc2": "MONSTER GALAXY P2Eは、大人気モバイルゲームシリーズのブロックチェーン版で、プレイヤーはNFTでモンスターペットを所有し、ゲーム内トークンを獲得およびアイテムと交換することができます。",
  "lp9_introduce_desc3": "<br>2011年に初めてリリースされて以来、2500万人以上のユーザーにプレイされているMONSTER GALAXYの最新版は、NFTとP2E（プレイして稼ぐ）ゲームの要素が新たに追加されています。\n  \n<br>MONSTER GALAXY P2Eでは、「MOGA」と呼ばれるモンスターを育成することができ、そのNFTはゲーム内ストアまたは他のNFTマーケットプレイスで取引することが可能です。MOGAは、7段階のレア度に分類されます。\n  \n<br>プレイヤーは、モンスターや他のプレイヤーと戦うことで、Galaxy Gems (GGM) と呼ばれるゲーム内トークンを獲得できます。 GGMは、ゲーム内のエネルギーやMOGA用の追加スロットを購入するために使用できます。 また、特権やステーキング報酬を獲得するために利用することも可能です。GGMおよびその他すべてのゲーム内アイテムは、サポートされているオープンマーケットで取引できます。",
  "lp9_project_desc": "NFTとP2Eを新たに搭載した伝説的モバイルゲーム",
  "lpCalculatorNoticeContent1": "算出された金額相当の資産をすでに追加入金済みで、通貨を出金していない場合は、抽選のために追加購入をする必要はありません。最終ウォレット残高は{time}12:30（日本時間）に更新されます。",
  "lpCalculatorNoticeContent2": "日次ウォレット残高は、1時間ごとのウォレット残高のスナップショットから算出されます。最終ウォレット残高は、日次ウォレット残高の平均値となります。",
  "lpCalculatorNoticeTitle": "注意",
  "lpCalculatorSubTitle2Ticket": "チケット2枚を獲得",
  "lpCalculatorSubTitle3Ticket": "チケット3枚を獲得",
  "lpCalculatorTicketOpt1": "オプション1：{time1}（UTC時間）までに現物で{tradingAmount} USDTを追加取引する",
  "lpCalculatorTicketOpt2": "オプション2：{time2}（UTC時間）までに現物で追加の{holdingsAmount} USDT相当を追加入金する",
  "lpCantToSubscribeSameUser": "各参加者が現在のローンチパッドに参加するために使用できる認証済みアカウントは1つのみとなります。このUID（{uid}）はローンチパッドの参加にすでに使用されています。そのため、現在のBybitアカウントを使用してローンチパッドに参加することはできません。",
  "lpCantToSubscribeTrade": "最低条件を満たしていません。次の計測期間中に対象となる入金を行ってください。",
  "lpCantToSubscribeUser": "You cannot join the event due to a restriction on your account. The event is not available for institutional users, users associated with institutional users, and managed users.",
  "lpGetTicketCongratulation": "おめでとうございます！トークン割り当て抽選への参加資格を得ました。抽選は{time}（UTC時間）に開始します。",
  "lpGetTicketTip": "抽選に参加登録した後、現在のVIPステータス、現物取引高、日次平均保有残高に基づいて{tickets}の抽選チケットが発行される予定です。",
  "lpHold": "保有する",
  "lpMoreTicketsBtnUpgradeVip": "VIPに更新",
  "lpMoreTicketsCountTip": "保有チケット枚数／最大取得可能枚数",
  "lpMoreTicketsSubTitle": "抽選には、3つの方法（VIPステータス、現物取引高、日次平均保有残高）で参加できます。ただし、これらの方法のうち実際に利用できるのは1つのみです。最も多くのチケットを取得できる方法でチケットを受け取ることになります。",
  "lpMoreTicketsTipBottom": "抽選チケットは、抽選に参加登録した後に発行されます。",
  "lpMoreTicketsTipCalculator": "必要な金額を<b>算出</b>してください。",
  "lpMoreTicketsTipCheck": "取引と資産保有データの確認はこちら",
  "lpMoreTicketsTradeMaxContent": "{date1}～{date2}まで、「現物で{TradingReqMax} USDT以上を取引」または「{HoldingReqMax} USDT以上の資産を保有」",
  "lpMoreTicketsTradeMaxTitle": "「現物で{TradingReqMax} USDT以上を取引」または「{HoldingReqMax} USDT以上の資産を保有」",
  "lpMoreTicketsTradeMinContent": "{date1}～{date2}まで、「現物で{TradingReqMin} USDT以上を取引」または「{HoldingReqMin} USDT以上の資産を保有」",
  "lpMoreTicketsTradeMinTitle": "「現物で{TradingReqMin} USDT以上を取引」または「{HoldingReqMin} USDT以上の資産を保有」",
  "lpMoreTicketsVipContent": "4枚の抽選チケットを受け取るには、{date}（UTC）以前にVIPステータスを取得する必要があります。",
  "lpMoreTicketsVipSuccessContent": "BybitのVIPステータスを取得すると、4枚の抽選チケットを受け取ることができます。",
  "lpMoreTicketsVipTitle": "VIPステータス",
  "lpn_active_income": "獲得トークン数量",
  "lpn_active_rule": "利用規約",
  "lpn_active_status1": "まもなく登場",
  "lpn_active_status2": "計測期間",
  "lpn_active_status3": "計測結果確認中",
  "lpn_active_status4": "コミット期間",
  "lpn_active_status5": "配布期間",
  "lpn_active_status6": "終了",
  "lpn_add_holdings": "抽選に参加するには、必要最低額以上の{currency}を保有している必要があります。",
  "lpn_add_holdings_trading": "抽選に参加するには、保有する{currency}の額および現物取引高が必要最低額以上である必要があります。",
  "lpn_add_ticket": "追加の抽選券",
  "lpn_add_ticket_tips": "追加の抽選券はコミットして抽選に参加した後に発行されます。",
  "lpn_allocation_announced_time": "割当結果は{time}（UTC時間）に発表予定です。",
  "lpn_amount_need": "必要な追加金額",
  "lpn_asset_table_th1": "時刻",
  "lpn_asset_tip": "資産計算が集中するため、現物、資産運用、資金調達、デリバティブ（またはUSDデリバティブとインバース）アカウント内の日次平均残高の更新が遅れることがあります。 入金してもすぐに残高表示に反映されないことがありますので、ご了承ください。",
  "lpn_available_balance": "利用可能残高（資金調達）:",
  "lpn_available_balance_tip": "利用可能残高には、コミット可能なMNTの最大額と現在の資金調達アカウントのMNT残高のうち、いずれか小さい方の値が表示されます。仮にコミット可能なMNTの最大額が3万MNTで、現在のMNT残高が2.9万MNTの場合、利用可能残高は2.9万MNTと表示されます。",
  "lpn_available_balance_tip_asset": "この利用可能残高には、コミット可能なBITの最大数量、または資金調達アカウントのBIT残高のどちらか値が小さい方が表示されます。コミット可能なBITの最大数量は30,000で、BIT残高が29,000だった場合、利用可能残高は29,000 BITになります。",
  "lpn_avg_growth": "平均上昇率",
  "lpn_banner_subtitle": "いち早くGETしよう",
  "lpn_banner_title": "Bybitで、新たなプロジェクトトークンを",
  "lpn_btn_experience": "今すぐ始める",
  "lpn_btn_go_kyc": "本人確認を行う",
  "lpn_btn_join_now": "今すぐコミット",
  "lpn_btn_lottery": "今すぐコミット",
  "lpn_btn_my_order": "コミット履歴",
  "lpn_btn_recharge_now": "今すぐ入金",
  "lpn_buy": "{currency}を購入する",
  "lpn_buy_explain": "カード決済、銀行振込などで購入",
  "lpn_buy_more": "さらに多くのトークン割当を獲得するには{currency}を購入してください。",
  "lpn_buy_now": "今すぐ購入",
  "lpn_calculator": "計算機",
  "lpn_calculator_holdings_required": "必要な最低保有資産",
  "lpn_calculator_notice": "注意",
  "lpn_calculator_time": "* {time} UTCまでに不足金を補う必要があります",
  "lpn_calculator_tips1": "最新スナップショットによると、抽選に参加するには<b>{holdingsAmount}</b>の追加購入または入金をして、{tradingAmount}</b>を取引する必要があります。",
  "lpn_calculator_tips2": "最新スナップショットによると、抽選に参加するには<b>{holdingsAmount}</b>を追加購入または入金する必要があります。",
  "lpn_calculator_tips3": "最新スナップショットによると、抽選に参加するには<b>{tradingAmount}</b>を追加で取引する必要があります。",
  "lpn_calculator_tips4": "最新スナップショットによると、抽選に参加するには<b>{holdingsAmount}</b>を追加で購入する必要があります。",
  "lpn_calculator_use": "必要な追加金額を算出してください。",
  "lpn_calculator_user_holdings": "現在の保有資産",
  "lpn_calculator_user_trading": "お客様の平均取引高",
  "lpn_canlendar": "マイスナップショット",
  "lpn_cap_lottery": "当選チケットごとの割当（抽選）",
  "lpn_cap_subscribe": "一人あたり割当上限（コミット）",
  "lpn_capita_income": "平均配布数",
  "lpn_card_notice1": "ログインして、本人確認を完了してください。",
  "lpn_card_notice8": "計測期間は終了しました。まもなく、コミットと抽選が始まります。",
  "lpn_card_only_abailable_vip": "VIP限定",
  "lpn_card_purchase_limits": "購入限度額",
  "lpn_card_vip_level_tip_supreme": "VVIP",
  "lpn_card_vip_level_tip_title": "一般のお客様は、こちらのトークン割当抽選会に参加することができません。",
  "lpn_card_vip_level_tip_user": "VIPのお客様",
  "lpn_choose_notice": "BITでコミットして購入する方法と、USDTで抽選に参加して購入する方法のどちらかをお選びいただけます！",
  "lpn_choose_notice_v2": "{currency}による申込方式、またはUSDTによる抽選方式のいずれかを選択いただけます。",
  "lpn_commit_more": "さらにコミット",
  "lpn_community_link": "始める",
  "lpn_community_tip": "iPhone 13 Pro と 賞金総額20,000ドル",
  "lpn_community_title": "Telegramの「Bybit現物コミュニティ」に参加して、iPhone 13 Proと賞金総額20,000ドルから分け前をゲットしよう！",
  "lpn_cover_enough_upgrade_vip": "トークン割当抽選会に参加するには、{time}（UTC）までにVIPステータスを獲得する必要があります。",
  "lpn_currency": "コミット対象トークン",
  "lpn_deposit": "{currency}を入金する",
  "lpn_deposit_explain": "個人ウォレット、あるいは他の取引所から送金",
  "lpn_deposit_trade": "入金／取引する",
  "lpn_deposit_trade_title": "入金＆取引で、抽選券を獲得しよう",
  "lpn_desc": "Bybitで有望なトークンを誰よりも早くゲット",
  "lpn_distribution": "配布",
  "lpn_distribution_time": "配布期間",
  "lpn_enable_lottery": "抽選の参加条件を満たしました。",
  "lpn_enable_subscribe": "コミットの参加条件を満たしました。",
  "lpn_exchange_rate_tip": "{number}ドル（{currency0}と{currency}の交換レートは、コミット期間開始時に確定）",
  "lpn_expand_more": "さらに表示",
  "lpn_faq": "よくある質問",
  "lpn_get_more_ticket": "もっと抽選券を獲得する",
  "lpn_get_ticket": "抽選への参加登録後に、登録時間と日次平均取引高に応じて、さらに{tickets}枚の抽選券を獲得できます。",
  "lpn_go_trade": "取引する",
  "lpn_higher_commit": "コミットする金額が多いほど、{token}トークンの割当も多くなります。1人あたりの上限は{limitAmount} {token}です。",
  "lpn_history": "過去の高利回りプロジェクト",
  "lpn_holdings": "{currency}の残高",
  "lpn_holdings_calculated": "スナップショットに基づく最終的な保有資産を計算中です。{time}（UTC時間）以降にご確認いただけます。",
  "lpn_holdings_calculator_title": "スナップショットに基づく{currency}残高の計算",
  "lpn_holdings_fail": "申し訳ございませんが、計測期間中の保有資産が必要最低額に達していません。",
  "lpn_holdings_trading_calculated": "スナップショットに基づく最終的な保有資産と平均取引高を計算中です。{time}（UTC時間）以降にご確認いただけます。",
  "lpn_holdings_trading_fail": "申し訳ございませんが、計測期間中の保有資産と日次平均取引高が必要最低額に達していません。",
  "lpn_holdings_trading_update": "日次平均保有資産と取引高は、{date}の12:00（日本時間）に更新されます。",
  "lpn_holdings_update": "日次平均保有資産は、{date}の12:00（日本時間）に更新されます。",
  "lpn_how_join": "参加方法",
  "lpn_index": "ホームページ",
  "lpn_index_avg_tips": "すべてのローンチパッドプロジェクトの1週間目の平均上昇率です。",
  "lpn_input_quantity": "コミット済み総額",
  "lpn_introduce": "CropBytes — バーチャル経済のゲーム",
  "lpn_introduce_desc2": "CropBytes、実世界の農業経済をベースとした暗号資産ゲームで、お客様はバーチャル世界で暗号資産の力を使って稼ぐことができます。CBXユーティリティトークンは、CropBytesメタバースのかけがえのない一部であり、ゲーム内の全てのアクティビティに関連しています。",
  "lpn_introduce_desc3": "<br>CropBytesメタバース内の値動きは需要と供給に完全に依存しているため、経済体制のコントロールはプレイヤー全員に委ねられます。\n \n <br>CropBytesにはゲーム内の取引所もあるので、プレイヤーはゲーム内でもシームレスに取引を行うことができます。\n \n <br>CropBytesはプレイヤーに代替性トークンと非代替性トークン（NFT）の両方を提供することで、低流動性などの問題を解決して、高頻度の取引を実現します。",
  "lpn_introduce_t1": "ソーシャルメディア",
  "lpn_introduce_t2": "プロジェクト紹介",
  "lpn_introduce_t3": "注目ポイント",
  "lpn_introduce_td3": "配布総額の{scale}",
  "lpn_introduce_td4": "{number}ドル（BITと{currency}の間の為替レートは、コミット期間前に確認されます）",
  "lpn_introduce_td7": "ロックなし",
  "lpn_introduce_td9": "配布期間中に配布",
  "lpn_introduce_th2": "総割当量",
  "lpn_introduce_th3": "初期配布額",
  "lpn_introduce_th4": "価格",
  "lpn_introduce_th5": "ローンチパッドに割り当てられた数量",
  "lpn_introduce_th6": "１人あたりの上限",
  "lpn_introduce_th7": "トークンロック期間",
  "lpn_introduce_th8": "トークン種別",
  "lpn_introduce_th9": "トークン配布形式",
  "lpn_investment": "投資",
  "lpn_invite": "お友達を紹介",
  "lpn_invite_ad": "お友達を招待すると、<b>最大120 MNT</b>の特典がもらえます！",
  "lpn_invite_ad2": "紹介したお友達が現物取引をすると、最大30％の手数料がもらえます！",
  "lpn_invite_go": "招待",
  "lpn_invite_now": "お友達紹介",
  "lpn_invite_rule": "仕組みについて",
  "lpn_invite_rule1": "1. ローンチパッドの紹介プログラムの仕組みを教えてください。\n・お友達に紹介リンクを共有してそのお友達にBybitに登録してもらい、今後開催予定のローンチパッドプロジェクトに参加してもらいます。紹介したお友達が条件を満たすと、特典としてMNTがもらえます。\n・特典の受け取り資格を得るには、紹介したお友達がBybitに登録し、特定のローンチパッドイベント中にトークン割り当てに応募するか抽選会に参加する必要があります。\n・ローンチパッドイベントの参加登録期間は、イベントの公式発表からコミット期間終了までの間となります。各イベントのスケジュールは、Bybitの公式SNSまたはローンチパッドの公式サイトでご確認ください。\n・1回のローンチパッドイベントで最大10名のお友達を招待できます。つまり、最大120 MNTの特典を入手可能です。\n・紹介したお友達がBybitのアフィリエイトになった場合、特典を受け取ることはできません。",
  "lpn_invite_rule2": "2. 特典はどのように配布されますか？\nローンチパッドイベントに招待したお友達が条件を満たした場合、そのローンチパッドイベントが終了してから1ヶ月後に、すべてのMNT特典がお客様の資金調達アカウントに入金されます。",
  "lpn_invite_rule2_asset": "<b>2. 特典はどのように配布されますか？</b>\n- ローンチパッドのイベントに招待した新規の被紹介者が条件を満たした場合、イベントが終了してから1ヶ月後に報酬のBITが紹介者の資金調達アカウントに配布されます。",
  "lpn_invite_tab1": "リンクをシェア",
  "lpn_invite_th1": "紹介が完了したお友達の人数",
  "lpn_invite_th2": "紹介が完了したごとに獲得できる特典",
  "lpn_invite_title": "お友達紹介でBITをもらおう",
  "lpn_invite_title_mnt": "お友達紹介でMNTをGET！",
  "lpn_is_high_vip_tip_text": "お客様はすでに、このトークン割当抽選会において最大購入限度額の枠を獲得しています。購入限度額は、{amount} {currency}となっています。",
  "lpn_issue_items_total": "プロジェクト",
  "lpn_join": "今すぐ参加する",
  "lpn_join_ad": "Bybitで、有望なプロジェクトの未上場トークンを誰よりも早く手に入れよう！",
  "lpn_join_go": "参加",
  "lpn_join_step": "タイムライン",
  "lpn_join_step1_desc": "<b>{date}</b>（UTC時間）以降のお客様の現物アカウント及び資産運用アカウントの日次平均BIT残高が{amount}以上である必要があります。（直近の整数に切り上げられます。）",
  "lpn_join_step1_desc_v2": "1. The daily average holdings of the committed token (MNT or USDT) and trading volume during the snapshot period must be equal to or greater than the minimum threshold amount. ",
  "lpn_join_step1_title": "計測期間",
  "lpn_join_step2_desc": "新規プロジェクトに一定額のBITをコミットすることができます。これを行うには、コミット期間中に「今すぐコミット」ボタンを押す必要があります。コミット可能なBITの最大額は、5日間の計測期間中の現物アカウント及び資産運用アカウントにおける日次平均BIT残高に基づいて算出されます。コミットされた額のBITがロックされ、最終{currency}を配布するまで振替、出金または取引を行うことができないことにご留意ください。",
  "lpn_join_step2_title": "コミット期間",
  "lpn_join_step3_desc": "お客様の獲得できる{currency}数量 = (コミット済みのBIT額 ÷ 全参加者がコミットしたBITの総額) × ローンチパッドの{currency}配布総額。お受け取りになれる最大{currency}額は{limit}枚です。上限を越えるトークン分は、まだ上限に達していない参加者に割り当てられます。実際に獲得できる{currency}の数量が決まると、お客様がコミットしたBITから対応する金額が差し引かれます。獲得できる{currency}と残りのBITはお客様の現物アカウントに戻されます。",
  "lpn_join_step3_title": "配布期間",
  "lpn_join_step4_date": "流動性の条件に達し次第、新たな現物通貨ペアが{date}（UTC時間）頃に取扱い開始となります。",
  "lpn_join_step4_title": "上場日時",
  "lpn_kyc_lottery": "抽選に参加するためには、本人確認レベル1を完了してください。",
  "lpn_kyc_subscribe": "コミットに参加するためには、本人確認レベル1を完了してください。",
  "lpn_launchpad": "ローンチパッド",
  "lpn_launchpool": "FreshCut Diamond (FCD)",
  "lpn_launchpool_desc": "FCDは、ゲームコンテンツプラットフォーム「FreshCut」のコミュニティトークンです。FreshCutは、create-and-earn（作って稼ぐ）およびengage-and-earn（参加して稼ぐ）ゲームプラットフォームであり、プレイヤーはトークンを稼いだりクリエイターに投げ銭を送ったりすることができます。",
  "lpn_launchpool_title": "ステーキングしてトークンをタダでもらおう",
  "lpn_learn_join": "参加方法",
  "lpn_link_bps": "ホワイトペーパー",
  "lpn_link_research": "プロジェクト詳細",
  "lpn_link_rule": "利用規約",
  "lpn_link_website": "ウェブサイト",
  "lpn_list": "ローンチパッド一覧",
  "lpn_log_snapshot": "ログインして最新のスナップショットに基づく計算をご確認ください。",
  "lpn_login": "ログイン",
  "lpn_lottery": "抽選",
  "lpn_lottery_announced_time": "抽選結果は{time}（UTC時間）に発表予定です。",
  "lpn_lottery_calculator_notice1": "日次平均保有資産は、ウォレット残高の1時間ごとのスナップショットから算出されます。日次平均ウォレット残高が、最終的なアカウントの保有資産となります。",
  "lpn_lottery_calculator_notice2": "最終的なアカウントの保有資産を計算中です。{time}（UTC時間）以降にご確認いただけます。",
  "lpn_lottery_calculator_notice3": "日次平均取引高は、計測期間中における現物取引高の1日ごとのスナップショットから算出されます。",
  "lpn_lottery_card_desc": "平均保有資産および取引高の両方が必要最低額に達したら、<b>{minPledgeAmount} {currency}</b>をコミットして抽選に参加し、{token}を獲得しましょう！当選した場合は、当選した抽選券1枚につき{limitAmount} {token}を獲得できます。",
  "lpn_lottery_card_desc_v2": "保有残高の条件を満たし、{minPledgeAmount} {currency}をコミットして抽選に当選すると、{token}を取得できます。当選チケット1枚につき{limitAmount} {token}を受け取ることができます。",
  "lpn_lottery_chosen": "どちらか一方しか選択できません。\n{currency}をコミットしてトークン割当抽選に参加しますか？",
  "lpn_lottery_confirm_tips": "抽選チケットに{amount1}{currency}をコミットした場合、当選チケット1枚当たり{amount2}の新規トークンを取得できます。",
  "lpn_lottery_currency": "{currency}で抽選に参加",
  "lpn_lottery_desc": "{currency}をコミットしてトークン割当抽選に参加する",
  "lpn_lottery_enbale": "抽選の参加条件を満たしました。抽選は{time}（UTC時間）に開始します。",
  "lpn_lottery_error_tips": "{currency1}のコミット抽選に参加すると、{currency2}をコミットして配布に参加することができなくなります。",
  "lpn_lottery_no": "お客様の抽選券番号",
  "lpn_lottery_not_cover_min_valom": "残念ながら、このローンチパッドの必須最低要件を満たしていません。次のローンチパッドの計測期間終了までに、現物取引高要件を満たすか、VIPステータスを獲得してください。",
  "lpn_lottery_rate": "当選確率",
  "lpn_lottery_start_time_tip": "抽選会は{time1}（UTC）に始まります。",
  "lpn_lottery_total": "総割当量（抽選）",
  "lpn_lottery_trading_tips": "資産の計算量が多いため、日次平均取引高の更新が遅れる場合があります。注文しても、表示される平均取引高にすぐに反映されない場合がありますのでご注意ください。",
  "lpn_lucky_limit": "1人あたりの上限 (抽選)",
  "lpn_min_holdings": "必要な最低平均保有資産",
  "lpn_min_holdings_tips": "日次平均保有資産は、計測期間中におけるアカウント残高の1時間ごとのスナップショットから算出されます。",
  "lpn_min_input": "最低コミット数量{quantity}{coin}より低いです",
  "lpn_more_ticket_title": "より多くの抽選券を獲得する方法",
  "lpn_more_trade": "取引すればするほど、より多くの抽選券を獲得できます。",
  "lpn_more_trade_content": "計測期間中（{date1}～{date2}）に日次平均現物取引高が必要最低額に達した場合、追加の抽選券をプレゼントします。",
  "lpn_new_rule1": "1.全ての参加者には、Bybitの利用規約が適用されます。",
  "lpn_new_rule2": "2.イベント規約に違反するような不正行為（ウォッシュトレーディング、ボリュームフェイク、複数のアカウント登録、市場操作など）を見つけた場合、Bybitは関連アカウントの参加資格を剥奪する権利を有します。",
  "lpn_new_rule3": "3.Bybitは、当イベント最終的な解釈の権利を有します。ご不明な点につきましては、カスタマーサービスまでお問い合わせください。",
  "lpn_new_rule4": "4.Bybitは事前通知なく、本キャンペーンの条件を変更する権利を有します。",
  "lpn_new_rule5": "5.このウェブサイトに掲載されているコンテンツは、米国内またはその行為が違法とされるその他の管轄区域において、米国人を対象に、もしくは米国人の口座や利益のために、証券の提供または販売を行うものではありません。\nBITトークンの送金は、適用法の下で法的規制の対象となる場合があります。いかなる状況においても、BITトークンは、米国内で、または米国人に対して、あるいは米国人の口座や利益のために、再提供、再販売並びに譲渡されてはなりません。但し、米国1933年証券法 (修正) の登録要件の免除に該当する、若しくは同法の登録要件に準じない取引は除外されます。\n米国でのBITトークンの公募は、発行者または販売を行うトークン保有者から取得されていて、企業と経営陣に関する詳細な情報と財務諸表を含む目論見書に基づいて行われます。",
  "lpn_new_rule5_v2": "本ウェブサイト内のコンテンツは、アメリカ合衆国内またはアメリカ合衆国在住者に対して、証券の提供または販売を行うものではありません。また、それが違法とされるその他の法域に対しても、証券の提供または販売を行うものではありません。\n\n{currency0}トークンの送金は、準拠法に基づく法規制の対象となる場合があります。いかなる場合においても、アメリカ合衆国内またはアメリカ合衆国在住者向けに{currency0}トークンを再提供、再販売または送金することはできません。ただし、アメリカ合衆国1933年証券法（改正後）の証券登録条件を免除された場合、またはその取引が証券登録条件の対象とならない場合を除きます。アメリカ合衆国における{currency0}トークンの公開販売は、発行者またはトークン販売者が提供する目論見書に基づいて行われます。この目論見書には、会社および経営に関する詳細情報ならびに財務諸表が含まれます。",
  "lpn_new_user": "新規のお客様には抽選券を1枚追加でプレゼントします。",
  "lpn_new_user_content": "イベント期間中（{date1}～{date2}）に登録した新規のお客様には、抽選券を1枚追加でプレゼントします。",
  "lpn_not_high_vip_tip_text": "購入限度額を{amount} {currency}まで増やすには、{time}（UTC）までにVIPランクをアップグレードする必要があります。",
  "lpn_not_vip_tip_text": "トークン割当抽選会に参加するには、{time}（UTC）までにVIPステータスを獲得する必要があります。",
  "lpn_notice_13": "計測時間が終了しました。間もなくコミット期間開始となります。",
  "lpn_notice10": "本イベントは終了しました",
  "lpn_notice11": "今回のプロジェクトからのトークン割当をご確認ください。トークンの現物通貨ペアはまもなく上場します。",
  "lpn_notice12": "ただいま計測期間中です。保有する{currency}を増やして、より多くの{currency}を獲得しましょう。残高のスナップショットは、翌日に更新されます。",
  "lpn_notice14": "抽選参加期間が始まりました。{currency}をコミットして、抽選に参加しましょう。",
  "lpn_notice15": "いずれかの参加方法からお選びください。",
  "lpn_notice16": "お客様の抽選番号は{number}です。",
  "lpn_notice17": "任意の通貨ペアで取引しよう！",
  "lpn_notice2": "イベント参加まであと1歩です！",
  "lpn_notice3": "まもなく計測期間が始まります。イベントの参加に必要な残高を用意してください。",
  "lpn_notice6": "ただいま計測期間中です。保有する{currency}を増やして、新トークンをより多く獲得しましょう。残高のスナップショットは、翌日に更新されます。",
  "lpn_notice7": "残念！日次平均残高がイベントの参加条件を満たしていません。",
  "lpn_notice8": "コミット期間が始まりました。{currency}をコミットして参加しましょう！",
  "lpn_notice9": "保有する{currency}を増やして、新トークンをより多く獲得しましょう。",
  "lpn_obtain_lottery_qualification": "おめでとうございます！{amount} {currency}をコミットすることで、トークン割当抽選会にご参加いただけます。",
  "lpn_ok": "確認",
  "lpn_one_progress_info": "結果発表まで",
  "lpn_one_progress_title": "配布中…",
  "lpn_only_vip_can_join": "VIPのお客様のみがこの抽選会に参加できます。",
  "lpn_order_amount": "投資額",
  "lpn_order_btn": "コミット済みプロジェクト",
  "lpn_order_btn_all": "全て",
  "lpn_order_btn_cancel": "キャンセル",
  "lpn_order_btn_confirm": "確定",
  "lpn_order_dialog_abailable_balance": "利用可能残高（資金調達）",
  "lpn_order_dialog_commit_amount": "コミット額",
  "lpn_order_dialog_title": "詳細",
  "lpn_order_max": "最大投資額",
  "lpn_order_max_tip": "BITの最大コミット可能額は、過去5日間の計測期間に記録されたBITの日次平均残高によって決まります。",
  "lpn_order_max_tip_v2": "MNTの最大コミット可能額は、過去5日間の計測期間に記録されたMNTの日次平均残高によって決まります。",
  "lpn_order_submit_success": "コミット成功",
  "lpn_order_submit_success_desc": "選択済みのプロジェクトに{num} {currency}コミットしました。",
  "lpn_order_submit_success_desc1": "抽選会に参加しました。",
  "lpn_order_tips": "ログインしてから、注文履歴をご確認ください。",
  "lpn_participant": "参加人数",
  "lpn_participants": "参加者",
  "lpn_paymeet_failed_dialog_buy_btn": "{currency}を購入",
  "lpn_paymeet_failed_dialog_content": "資金調達アカウントの残高が不足しています。申し込みをするには、追加で{amount} {currency}を購入または入金する必要があります。",
  "lpn_paymeet_failed_dialog_deposit_btn": "{currency}を入金",
  "lpn_paymeet_failed_dialog_title": "支払いに失敗しました",
  "lpn_price": "価格",
  "lpn_product_life": "プロジェクト期間",
  "lpn_profit": "上場1週目の平均収益率",
  "lpn_profit_tips": "上場1週目の平均収益率＝上場1週目の平均価格 ÷ 上場価格 × 100%",
  "lpn_project_desc": "メタバースで暗号資産ファームを作り上げよう",
  "lpn_project_info": "今回のプロジェクトについて",
  "lpn_project_status0": "計測期間開始まで",
  "lpn_project_status1": "コミット期間開始まで",
  "lpn_project_status2": "コミット期間終了まで",
  "lpn_project_status3": "配布期間終了まで",
  "lpn_project_status4": "終了",
  "lpn_record_endtime": "終了日",
  "lpn_record_name": "プロジェクト",
  "lpn_record_name_tip": "プロジェクト名を入力",
  "lpn_record_starttime": "開始日",
  "lpn_record_state0": "保留",
  "lpn_record_state1": "配布中",
  "lpn_record_state2": "配布済",
  "lpn_record_th1": "時点",
  "lpn_record_th3": "コミット済みのトークンの枚数",
  "lpn_record_th3_m": "投資済みの{currency}数量",
  "lpn_record_th4": "価格",
  "lpn_record_th5": "差引かれたトークンの枚数",
  "lpn_record_th6": "トークンの配布数量",
  "lpn_record_th7": "ステータス",
  "lpn_records": "履歴",
  "lpn_register": "登録する",
  "lpn_register_ticket": "登録が完了しました。抽選券を1枚獲得しました。",
  "lpn_required_holdings": "必要な平均保有資産",
  "lpn_required_trading": "必要な平均取引高",
  "lpn_required_trading_tips": "日次平均取引高は、計測期間中における現物取引高の日次スナップショットから算出されます。",
  "lpn_required_tradings": "現物取引高要件",
  "lpn_reset": "リセット",
  "lpn_restricted_country": "アクセス制限地域",
  "lpn_restricted_country_tip": "Bybitは、米国、中国本土、シンガポール、ケベック (カナダ)、北朝鮮、キューバ、イラン、クリミア、セヴァストポリおよびスーダンの居住者または国民には、サービスや製品を提供していません。",
  "lpn_result_time": "配布数量",
  "lpn_result_title": "結果",
  "lpn_rewards_check_reason": "失敗の理由",
  "lpn_rewards_default_name": "過去のローンチパッドイベント",
  "lpn_rewards_faile_reason": "現在、お客様はエアドロップの受け取り対象外となっています。Bybitから異議申し立てを行い、「ケースタイプ」で「キャンペーン」→「特典」→「ローンチパッド」を選択してください。",
  "lpn_rewards_orders": "マイ紹介特典",
  "lpn_rewards_request": "異議申し立てを行なう",
  "lpn_rewards_source1": "{uid}がイベントに参加",
  "lpn_rewards_source2": "過去の参加者数",
  "lpn_rewards_status_faile": "失敗",
  "lpn_rewards_status_pending": "処理中",
  "lpn_rewards_status_success": "配布済",
  "lpn_rewards_status_tips": "特典は、ローンチパッドイベント終了後、7営業日後にお客様の現物アカウントに配布されます。特典を受け取れなかった場合は、「失敗の理由」をクリックして詳細をご確認ください。",
  "lpn_rewards_status_tips_asset": "特典はローンチパッドのイベントが終了してから7営業日後に資金調達アカウントに配布されます。特典を受け取らなかった場合は、[失敗の理由] をクリックして詳細を確認してください。",
  "lpn_rewards_th_event": "ローンチパッドイベント",
  "lpn_rewards_th_rewards": "紹介特典",
  "lpn_rewards_th_source": "参加者数",
  "lpn_rules": "利用規約",
  "lpn_scroll_load": "下にスクロールして表示",
  "lpn_select_deposit": "暗号資産を用意する",
  "lpn_share_earn": "シェアして特典GET",
  "lpn_share_img_content": "お友達紹介で、最大120 MNTがもらえる！",
  "lpn_share_text": "一緒にBybitのローンチパッドに参加して、有望なプロジェクトの新規トークンを上場前に手に入れよう！ここから始めよう→{link}",
  "lpn_share_text_label": "紹介メッセージをカスタマイズ",
  "lpn_snapshot_buy_currency": "{currency}を購入・入金して、入手できるトークン数を増やします。",
  "lpn_snapshot_desc_content1": "5日間の計測期間中に、現物アカウント、資産運用アカウント、資金調達アカウント、デリバティブアカウント（またはUSDデリバティブアカウント）の、日次平均保有資産を1時間ごとにスナップショットで記録します。日次平均保有資産は、翌日の12:00（日本時間）に更新されます。\n\n例：10月29日に田中さんがBybitアカウントを登録し、6:00（日本時間）から1時間ごとに100 BITを入金（現物アカウントにのみ）したとします。1時間ごとの残高スナップショットは、6:00に100 BIT、7:00に200 BIT、8:00に300 BITとしてそれぞれ記録されます。この場合、田中さんの10月29日の現物アカウントのBITの日次平均保有残高は25 BIT*となります。\n\n*[(100 + 200 + 300) ÷ 24] = 25\n\n10月30日12:00以降に、田中さんの10月29日の日次平均BIT保有残高（現物アカウント）が25 BITに更新されていることを確認できます。",
  "lpn_snapshot_desc_content1_asset": "5日間のスナップショット期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（またはUSDデリバティブアカウント、統合取引アカウント、インバースデリバティブアカウント）の日次平均残高は、1時間毎のスナップショットで記録されます。日次平均残高は、翌日の12:00（日本時間）に更新されます。\n\n例：\n10月28日に田中さんがBybitアカウントを開設し、6:00（日本時間）から資金調達アカウントに100 BITを1時間置きに入金したと仮定します。田中さんの1時間毎の残高スナップショットは、6:00（日本時間）に100 BIT、7:00（日本時間）に200 BIT、8:00（日本時間）に300 BITとして記録されます。この時、10月28日時点の資金調達アカウントの日次平均BIT残高は25 BIT*となります。\n\n*[(100 + 200 + 300) ÷ 24] = 25\n\n田中さんの10月28日の日次平均BIT残高（資金調達アカウント）は、10月29日12:00（日本時間）に25 BITに更新されます。",
  "lpn_snapshot_desc_content2": "4日間の計測期間中は、現物取引、現物コピートレード、現物取引ボット、積立ボット、現物マージン取引、レバレッジトークンの合計日次平均取引高が毎日スナップショットとして記録されます。これには、買いと売りの全取引が含まれます。デリバティブの取引高はカウントされませんのでご注意ください。合計日次平均取引高は、翌日の12:00（日本時間）に更新されます。\n\nUSDT建てのペアの場合、取引高は約定されたUSDT注文のすべての注文価額の合計となります。USDT建てではないペアについては、取引高はその日の終値でUSDTに換算されます。\n\nたとえば、10月28日に田中さんがBybitに登録し、6:00（日本時間）に100 USDT、7:00に200 USDTの現物取引をしたとします。その場合、田中さんの日次取引高のスナップショットは、300 USDTとして記録されます。この場合、計測期間中の最終的な日次平均取引高は60 USDT*となります。\n\n*(100 + 200) ÷ 5 = 60\n\n10月29日12:00（日本時間）以降、田中さんは10月28日の日次平均取引高が60 USDTであることを確認することができます。",
  "lpn_snapshot_desc_content2_v2": "{snapshot_days}日間の計測期間中、お客様の現物取引、現物コピートレード、グリッド取引ボット、積立ボット、現物マージン取引、レバレッジトークンの合計取引高が毎日スナップショットで記録されます。この取引高には、お客様のすべての売りと買いの取引が含まれます。デリバティブ取引の取引高はスナップショットに含まれませんのでご注意ください。その日の日次平均取引高の合計は、翌日の3:00（UTC時間）に更新されます。\n\nUSDT建て通貨ペアの場合、約定した各USDT注文の注文額の合計が取引高となります。非USDT建て通貨ペアの場合、その日の終値でUSDTに換算した金額が取引高となります。\n\n例えば、田中さんが10月28日にBybitアカウントを作成し、21:00（UTC時間）に100 USDTの現物取引を行い、その22:00（UTC時間）に200 USDTの現物取引を行ったとします。この場合、計測期間中の合計取引高は300 USDTになります。\n\n100 + 200 = 300\n\n10月29日3:00（UTC時間）以降、田中さんの10月28日の日次合計取引高は300 USDTに更新されます。",
  "lpn_snapshot_desc_content3": "計測期間中の現物アカウント、資産運用アカウント、資金調達アカウント、デリバティブアカウント（またはUSDデリバティブアカウント）の日次平均保有資産は、最低基準額以上（小数点以下は切り捨て）である必要があります。\n\n現物アカウント、資産運用アカウント、資金調達アカウント、デリバティブアカウント（またはUSDデリバティブアカウント）の日次平均保有資産は毎日12:00（日本時間）に更新されます。ただし、資産の計算量が多いため、日次平均保有資産の更新が遅れる場合があります。",
  "lpn_snapshot_desc_content3_asset": "スナップショット期間中の資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウント、インバースデリバティブアカウント）の日次平均残高は、最低基準額以上（小数点以下は切り捨て）である必要があります。\n\n資金調達アカウント、現物アカウント、デリバティブアカウント（またはUSDデリバティブアカウント、統合取引アカウント、インバースデリバティブアカウント）の日次平均残高は、毎日12:00（日本時間）に更新されます。ただし、計算量が多い場合は日次平均残高の更新が遅れる可能性があります。",
  "lpn_snapshot_desc_title1": "保有資産はどのように計算されますか？",
  "lpn_snapshot_desc_title1_v2": "「MNTコミット方式」または「USDT抽選方式」の保有残高の計算方法を教えてください。",
  "lpn_snapshot_desc_title2": "日次平均取引高はどのように計算されますか？",
  "lpn_snapshot_desc_title2_v2": "現物取引の条件でチケットを取得する場合、取得できるチケット枚数（2枚または3枚）はどのように決定されますか？",
  "lpn_snapshot_desc_title3": "計測に関するルール",
  "lpn_snapshot_holding": "保有資産の詳細",
  "lpn_snapshot_holdings_title": "{currency}残高のスナップショット",
  "lpn_snapshot_th_trading": "取引高",
  "lpn_snapshot_trading": "取引高の詳細",
  "lpn_snapshot_trading_title": "取引高のスナップショット",
  "lpn_snapshot_update_time": "{date}の12:00（日本時間）に更新予定。",
  "lpn_snapshots": "計測",
  "lpn_snapshots_time": "計測期間",
  "lpn_spot_trading": "現物取引",
  "lpn_step_tips1": "<b>参加条件を満たす</b>スナップショット期間終了前にコミットに必要なBITまたはUSDTを入金して、参加しましょう！",
  "lpn_step_tips1_v2": "<b>参加資格を得る：</b>計測期間が終了する前にMNTまたはUSDTを入金し、ウォレット残高が応募条件または抽選条件を満たしていることを確認する必要があります。",
  "lpn_step_tips2": "<b>コミットする</b>BITをコミットして割当申込に参加するか、USDTをコミットして割当抽選に参加します。",
  "lpn_step_tips2_v2": "<b>今すぐコミット：</b>MNTをコミットして申し込む方法と、USDTをコミットして抽選に参加する方法のどちらかをお選びいただけます。",
  "lpn_step_tips3": "<b>配布期間：</b> MNTコミット参加者の割当数量が算出され、USDTコミット参加者の抽選会が行われます。",
  "lpn_step_tips4": "<b>結果を確認する</b>割当結果の発表後に、割当枚数を確認できます。新たに入手したトークンは、現物通貨ペアの上場後に取引できます！",
  "lpn_sub_tip_text": "ローンチパッドのイベント通知を設定して、最新情報を受け取ろう！",
  "lpn_subscribe": "コミット",
  "lpn_subscribe_chosen": "どちらか一方しか選択できません。\n{currency}をコミットしてトークン割当を獲得しますか？",
  "lpn_subscribe_currency": "{currency}で申し込む",
  "lpn_subscribe_desc": "トークンの割り当てを受けるために、{currency}をコミットして申し込みます。",
  "lpn_subscribe_error_tips": "{currency1}をコミットして配布に参加したお客様は、{currency2}のコミット抽選に参加することができなくなります。",
  "lpn_subscribe_total": "総割当量（コミット）",
  "lpn_subscription": "コミット",
  "lpn_subscription_holding_tips": "現物アカウント、資産運用アカウント、資金調達アカウント、デリバティブアカウント（またはUSDデリバティブアカウント）の日次平均保有資産は、資産の計算量が多いため、更新が遅れることがあります。入金しても、表示される残高にすぐに反映されない場合がありますのでご注意ください。",
  "lpn_subscription_holding_tips_asset": "資産計算を大量に実行する場合、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウント、USDデリバティブアカウント、インバースデリバティブアカウント）の日次平均残高の更新に遅延が発生する可能性があります。お客様の入金がすぐに残高に反映されない場合もありますのでご注意ください。",
  "lpn_subscription_time": "コミット期間",
  "lpn_subscription_time2": "「コミット」または「抽選」方式で参加",
  "lpn_subscriptions_orders": "マイコミット",
  "lpn_subscrption_card_desc": "平均保有資産が必要最低額に達した場合は、{minPledgeAmount} {currency}以上（1人あたりの上限は{limitAmount} {token}）の{token}の割当を申し込んでください。",
  "lpn_tail_digit": "{num} Tail Digit",
  "lpn_tail_digit_num": "最後の{number}桁",
  "lpn_tail_digit_num1": "最後の1桁",
  "lpn_tail_digits": "当選番号",
  "lpn_tail_digits_th1": "一致",
  "lpn_tail_digits_th2": "当選番号",
  "lpn_time_label": "日付",
  "lpn_token_calculation": "配布中…",
  "lpn_total_amount": "合計投資額",
  "lpn_total_funds_raised": "コミット済み総額（ドル換算）",
  "lpn_total_rewards": "特典の合計（MNT）",
  "lpn_trade": "取引する",
  "lpn_trade_desc": "現物市場で暗号資産を売買します。",
  "lpn_trade_detail_entry": "取引高の詳細",
  "lpn_trade_statistics_rule_tips": "計測期間終了日までの30日間（{date1}〜{date2} UTC）における現物取引高は、現物取引高要件を満たすための取引高として考慮されます。これには、現物取引、現物マージン取引、レバレッジトークン取引、現物取引ボットおよび積立ボットでの取引が含まれ、この30日間で行われるすべての売買がカウントされます。",
  "lpn_trade_volume_cover_enough": "トークン割当抽選会の参加に必要な日次平均保有残高の条件を満たしています。",
  "lpn_trade_volume_not_enough": "残念ながら、計測期間終了日（{date1}～{date2} UTC）以前の過去30日間における現物取引高が条件を満たしませんでした。取引高計算ツールを使用して、追加で必要となる取引高を算出してください。",
  "lpn_trade_volume_update_time": "現物取引高は、{date}3:00（UTC）に更新されます。",
  "lpn_trading_calculator_title": "日次平均取引高の計算",
  "lpn_trading_fail": "申し訳ございませんが、現在の日次平均取引高が必要最低額に達していません。",
  "lpn_two_progress_info": "配布完了まで",
  "lpn_two_progress_title": "配布・抽選中…",
  "lpn_unable_snapshot": "申し訳ございませんが、必要最低額に達していません。抽選に参加するには、次回の測定期間中に入金するか、取引高を増やしてください。",
  "lpn_unsub_dialog_cancel": "キャンセル",
  "lpn_unsub_dialog_confirm": "確定",
  "lpn_unsub_dialog_text": "設定を解除しますか？ローンチパッドのリリースイベント、スナップショット、コミット、トークン割当に関する通知が届かなくなります。",
  "lpn_unsub_dialog_title": "通知",
  "lpn_up_to": "最大120 MNT",
  "lpn_upgrade_to_vip": "VIPにアップグレード",
  "lpn_upgrade_to_vip_current_level": "現在のVIPランク",
  "lpn_upgrade_vip_btn_text": "VIPランクをアップグレード",
  "lpn_upper_limit": "一人あたり割当上限（コミット）",
  "lpn_user_center": "ユーザーセンター",
  "lpn_view_all": "プロジェクトを見る",
  "lpn_view_details": "詳細を見る",
  "lpn_vip_calculator_notice1": "すでに取引高計算ツールで示された金額分の取引高を増やしている場合は、追加の取引をしなくても抽選会にご参加いただけます。最終取引高は、{time}3:30（UTC）に更新されます。",
  "lpn_vip_calculator_notice2": "計測期間終了日までの30日間（{date1}〜{date2} UTC）における現物取引高は、現物取引高要件を満たすための取引高として考慮されます。これには、現物取引、現物マージン取引、レバレッジトークン取引、現物取引ボットおよび積立ボットでの取引が含まれ、この30日間で行われるすべての売買がカウントされます。デリバティブの取引高はカウントされませんのでご注意ください。合計日次平均取引高は、翌日の3:00（UTC）に更新されます。",
  "lpn_vip_calculator_user_trading_vol": "お客様の取引高",
  "lpn_vip_card_desc": "VIPランクに応じて{amount1}～{amount2}をコミットし、取引高要件を満たすことで、抽選に参加して{token}を獲得できます。当選後、コミット額に応じて{limitAmount1}～{limitAmount2} {token}を受け取れます。",
  "lpn_vip_detail_card_login_tip": "ログインして購入限度額をご確認ください。",
  "lpn_vip_last_day_time": "* {time}（UTC）までに条件を満たす必要があります。",
  "lpn_vip_level_token_tip": "（当選者1人当たり{amount} {token}）",
  "lpn_vip_lottery_title": "トークン割当抽選会に参加するには、現物取引高要件を満たす必要があります。",
  "lpn_vip_not_join_account_tip": "アカウントが制限されているため、本イベントにご参加いただけません。本イベントは、機関投資家、機関投資家の関係者、および管理されているユーザーの方はご参加いただけません。",
  "lpn_vip_not_kyc_tip1": "現在、最終取引高を算出中です。",
  "lpn_vip_not_kyc_tip2": "結果は{time}（UTC）以降にご確認いただけます。",
  "lpn_vip_order_dialog_title": "{amount1} {currency}をコミットすると抽選券1枚を獲得できます。当選すると{amount2}トークンを受け取れます！",
  "lpn_vip_project_title": "{token}をコミットして、トークン割当抽選会に参加しよう。",
  "lpn_vip_trade_btn": "取引する",
  "lpn_vip_trade_val_fail": "残念ながら、このローンチパッドの必須最低要件を満たしていません。次のローンチパッドの計測期間終了までに、現物取引高要件を満たすか、VIPステータスを獲得してください。",
  "lpn_vip_user_need_trading_vol_tip": "最新のスナップショットによると、抽選会に参加するにはあと<b>{amount} USDT</b>を追加で取引する必要があります。",
  "lpn_vip_volume_calculator": "取引高計算ツール",
  "lpn_win_benefits": "当選者一人あたり割当数量",
  "lpn_win_prize": "当選チケットごとの割当",
  "lpn_your_card_purchase_limits": "お客様の購入金額",
  "lpSnapshotDescContent3": "{snapshot_days}日間の計測期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）にあるすべての暗号資産の日次平均保有残高が1時間ごとのスナップショットで記録されます。その日の日次平均保有残高は、翌日の3:00（UTC時間）に更新されます。\n\nUSDT以外の暗号資産の場合、その日の終値でUSDTに換算した金額が保有残高となります。\n\n例えば、田中さんが10月28日にBybitアカウントを作成し、21:00（UTC時間）から1時間ごとに100 MNTを資金調達アカウントに入金したとします。この場合、1時間ごとの残高のスナップショットは、「21:00（UTC時間）→100 MNT、22:00（UTC時間）→200 MNT、23:00（UTC時間）→300 MNT」として記録されます。また、10月28日の現物アカウントのMNTの日次平均保有残高は25 MNTになります。\n\n[(100 + 200 + 300) ÷ 24] = 25\n\n10月28日のMNT/USDTの終値が1 USDTであった場合、10月29日3:00（UTC時間）以降、田中さんの10月28日の日次平均保有残高は25 USDTに更新されます。\n\n25 × 1 = 25USDT",
  "lpSnapshotDescTitle1Lottery": "How are my holdings calculated for MNT subscription or USDT lottery?",
  "lpSnapshotDescTitle3Lottery": "資産保有額の条件でチケットを取得する場合、取得できるチケット枚数（2枚または3枚）はどのように決定されますか？",
  "lpSnapshotTabTitle": "全資産のスナップショット",
  "lpSnapshotTradingTh": "全資産保有額",
  "lpTickets": "チケット",
  "lpTrade": "取引する",
  "lpTradeOrDeposit": "取引 / 入金",
  "lpTransfer": "振替",
  "MARKET": "市場価格",
  "max": "最大",
  "mntSubscriptionJoinedNotice": "MNTをコミット済みのため、割当抽選に参加することができません。",
  "more": "詳しく見る",
  "myBenefits": "マイ特典 ",
  "mySnapshotData": "スナップショットのデータ",
  "needAdditionalAmountForLottery": "割当抽選に参加するために、<b>{additional_amount} {currency}</b>を追加で購入または入金する必要があります。表示されているUSDTは、資金調達アカウント、現物アカウント、およびデリバティブアカウント（または総合取引アカウントおよびインバースアカウント）のMNTまたはUSDTの残高を除いて、メインアカウントの現在の利用可能残高のみを表します。詳しいスナップショットの説明については、以下の説明を参照してください。",
  "network_error": "申請に失敗しました。しばらくしてから、もう一度お試しください。",
  "NEW": "アクティブ",
  "next_page": "次へ",
  "no_more_text": "以上",
  "nodata": "履歴が見つかりませんでした。",
  "none": "なし",
  "nonUsdtAssetsConversion": "USDT以外の資産の場合、保有残高はその日の終値に基づきUSDTに変換されて計算されます。",
  "nonUsdtPairsTradingVolumeConversion": "USDT建て以外の通貨ペアの場合、取引高はその日の終値に基づきUSDTに変換されて計算されます。",
  "notCountedTradingVolume": "以下の商品における取引高はカウント対象外です。",
  "notice": "注：",
  "notIncludedTradingTypes": "現物取引、現物コピートレード、現物取引ボット、積立ボット、現物マージン取引、レバレッジトークン、API取引による売買は含まれません。",
  "officalWebsite": "ウェブサイト",
  "og_title": "{symbol} | 安い手数料で暗号資産を購入、売却、取引しよう | Bybit 現物取引",
  "ongoing": "開催中",
  "onGoing": "開催中",
  "operationSuccess": "成功",
  "or": "または",
  "orderAmount": "订单总额",
  "orderBook": "取引板",
  "orderHistory": "注文履歴",
  "orderId": "注文ID",
  "orderType": "注文タイプ",
  "otcErrorInfo": "お客様はすでにOTCレンディングを有効化しているため、マージン取引機能をご利用いただけません。",
  "outstanding": "未払い",
  "pastPerformance": "過去のプロジェクト",
  "previous_page": "前へ",
  "price": "価格",
  "quantity": "数量",
  "referAndEarn": "お友達紹介で豪華特典をGET！",
  "referFriendsEarnToget": "お友達を紹介して一緒にゲットしよう！",
  "referralHistRules": "紹介履歴と規約",
  "registeredSuccessfully": "エントリー完了",
  "registerEventIdentityVerification": "イベントにエントリーするには、本人確認（KYC）レベル1を完了する必要があります。",
  "registerNow": "今すぐエントリー",
  "registerToJoinLottery": "割当抽選に参加するにはエントリーが必要です。",
  "registerToJoinSubscription": "コミットするにはエントリーが必要です。",
  "reset": "リセット",
  "resultsAnnouncementTime": "結果発表はこちら→",
  "resultsWillBeAnnounced": "結果発表はこちら→",
  "reverse_contract_account": "インバースアカウント",
  "riskWarning": "リスクの確認",
  "saleEndsIn": "セール終了まで残り：",
  "saleEndsIn1": "セール終了まで残り",
  "saleInfo": "トークンセール概要",
  "saleStartsIn": "セール開始まで残り：",
  "saleStartsIn1": "セール開始まであと",
  "search": "検索",
  "secureEarlyAccess": "将来有望なプロジェクトのトークンをいち早く入手できます。MNTを使用してトークンセールにコミットするか、USDTで割当抽選に参加しましょう。計測期間中の保有金額によって、コミット額およびトークン割当抽選の当選確率が決まります。",
  "shareAndEarn": "シェア＆配分をGET",
  "sharePrizePool": "お友達にシェアして、{prizepool} {token}の賞金プールから配分を受け取ろう！",
  "shareToEarn": "シェア＆配分をGET",
  "side": "売り/ 買い",
  "signup": "登録",
  "snapshotBalancesCounted": "スナップショット期間中、どの残高がカウントされますか？",
  "snapshotPeriodRecord": "{time1}～{time2}（UTC）の計測期間中、資金調達アカウント、現物アカウント、デリバティブアカウント（または統合取引アカウントとインバースアカウント）における資産残高が、1時間ごとのスナップショットで記録されます。",
  "snapshotPeriodTradingVolumeRecord": "{x}日間の計測期間中、以下の商品における合計取引高が、日次スナップショットで記録されます。",
  "snapshotPeriodVolumeRecord": "<p>3. 計測期間中は、現物取引、現物コピートレード、現物取引ボット、積立ボット、現物マージン取引、レバレッジトークンの合計取引高が毎日スナップショットとして記録されます。これには、買いと売りの全取引が含まれます。USDT建て通貨ペアの場合、取引高は、約定した各USDT注文の合計注文価額として計算されます。USDT建て以外の通貨ペアの場合、取引高は、その日の終値に基づきUSDTに変換されて計算されます。API取引、デリバティブ取引、コピートレードPro、および手数料無料の現物通貨ペアの取引高はカウントされませんのでご注意ください。</p>",
  "snapshotResultsPeriodUtc": "{time1}～{time2}（UTC）の計測期間におけるスナップショットの結果は次のとおりです。",
  "snapshotsRules": "スナップショット規定",
  "spot_account": "現物アカウント",
  "spotAccount": "現物アカウント",
  "spotCopyTrading": "現物コピートレード",
  "spotMarginTrading": "現物マージン取引",
  "spotTrading": "現物取引",
  "spotTradingReqCalculationQualification": "現物取引が要件の場合、抽選券を2枚または3枚獲得できるかどうかは、どのように決まりますか？",
  "spotTradingVolCopyTrdPro": "コピートレードProを使用した現物取引高",
  "spotTradingVolume200Usdt": "現物取引高 = 200 USDT",
  "spotTradingVolume300Usdt": "現物取引高 = 300 USDT",
  "spotTradingVolumeUsdt": "現物取引高 = 100 USDT",
  "spotTradingVolumeZeroFees": "手数料無料の通貨ペアの現物取引高",
  "status": "状態",
  "step": "Step",
  "stop_limit": "利食/損切",
  "stop_limit_tips_2": "アクティブな利食・損切注文がある場合は、マージン取引を有効にすることはできません。",
  "subBtnText": "購読する",
  "subscribeOrJoinLottery": "MNTでコミット、またはUSDTで割当抽選に参加可能",
  "subscribeToBuyTokenWithCurrency": "{currency}をコミットして{token}を購入する",
  "subscribeTokenWithAvgBal": "{minPledgeAmount} {currency}以上の平均アカウント残高をコミットして{token}を購入します。",
  "subscriptionEligibilityConfirmation": "おめでとうございます！お客様にはコミットする資格があります。",
  "subscriptionEligibilityInfo": "すでに提案された{currency}を追加で購入または入金済みで、いかなる通貨の出金や売却を行っていない場合は、コミットするために再度購入・入金を行う必要はありません。最終的な平均保有残高は、{time}の3:30（UTC）に更新されます。",
  "subscriptionHoldingsError": "日次平均保有残高が条件を満たさないため、コミットを行えません。次回のローンチパッドに参加する際は、十分な{currency}を入金するようにしてください。",
  "subscriptionPeriodCalc": "コミット期間中、どのように最終的なトークン割当額を計算できますか？",
  "subToastSuccess": "購読しました",
  "success": "完了",
  "sure": "sure",
  "theTokenSaleHasAlreadyEnded": "トークンセールは終了しました。",
  "times": "回",
  "timestamp": "時間",
  "title_404": "404 {'|'} Bybit現物取引  ",
  "title_exchange": "{close} {'|'} {symbols} {'|'} Bybit現物取引 ",
  "to": "～",
  "toastTheSymbolNotExist": "お選びになった現物ペアは、現在取引に利用できません。",
  "tokenLaunchpadUpdateNotice": "残念ながら、お客様の保有残高は{{TOKEN_NAME}}のローンチパッド参加条件を満たしていません。タップして詳細をチェック 👉",
  "tokenSale": "トークンセール",
  "tokenSaleEligibilityError": "{time1}〜{time2}（UTC）の期間中にイベントに参加しなかったため、トークンセールに参加することができません。",
  "tokenSaleRecords": "トークンセールの終了日",
  "tokenSaleSubscriptionError": "お客様はすでにUSDTで割当抽選に参加することを選択しているため、MNTをコミットしてトークンセールに参加することはできません。",
  "total": "合計",
  "totalSupply": "総供給量",
  "tradingPairs": "現物取引ペア",
  "tradingVolume": "取引高",
  "transactionRecords": "これには、買いと売りの全取引が含まれます。 ",
  "transfer": "資産振替",
  "transferableBalanceNotEnough": "振替に失敗しました！残高不足です。",
  "turnover": "約定価額",
  "unifiedTradingAccount": "統合取引アカウント",
  "unsubBtnText": "購読を解除",
  "unsubToastSuccess": "購読が解除されました",
  "updateDailyAvgMntHoldings": "この場合、2月23日におけるMNTの日次平均保有残高は、25 MNTとなります（2月24日3:00（UTC）以降にデータが更新されます）。",
  "updateDailyHoldingsFeb23": "MNT/USDTの終値が1 USDTと仮定した場合、2月23日における日次平均保有残高は、25 USDTとなります（2月24日3:00（UTC）以降にデータが更新されます）。",
  "updateTradeVolumeFeb23": "この場合、2月23日の合計取引高は、600 USDTとなります（2月24日3:00 UTC 以降にデータが更新されます）。",
  "updateUsdtHoldingsFeb23": "この場合、2月23日におけるUSDTの日次平均保有残高は、25 USDTとなります（2月24日3:00（UTC）以降にデータが更新されます）。",
  "usdc_contract_account": "USDCデリバティブアカウント",
  "usdtHoldings": "USDT保有残高",
  "usdtPairsTradingVolumeSum": "USDT建て通貨ペアの場合、取引高は約定した各USDT注文の合計注文価額として計算されます。 ",
  "viewDetails": "詳細を見る",
  "volume": "約定数量",
  "walletBalanceInUsdt": "ウォレット残高 = 100 USDT",
  "walletBalanceMnt100": "ウォレット残高 = 100 MNT",
  "walletBalanceMnt200": "ウォレット残高 = 200 MNT",
  "walletBalanceMnt300": "ウォレット残高 = 300 MNT",
  "walletBalanceUsdt200": "ウォレット残高 = 200 USDT",
  "walletBalanceUsdt300": "ウォレット残高 = 300 USDT",
  "whiteBook": "ホワイトペーパー",
  "whoIsEligible": "Bybitローンチパッドへの参加条件はありますか？",
  "winningNumber": "当選番号："
}